import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark, } from "@/shared/Constants";

export const ContainerCollectionSaveExit = styled.div`
   /*  display: none;
    &.isOpen {
        display: flex;
    } */
        width: 100%;
        padding-bottom: 0.75rem;
        position: relative;
     a, p {
        ${Font.sansRegular};
        font-size: 20px;
        line-height: 26px;
        color: ${Color.grey};
        text-align: left;
     }
     a.link__collection{
        color: ${Color.mainColor};
        text-decoration: underline;
        margin-left: 0;
        white-space: nowrap;
     }
     button {
        all: unset;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
     }
`;